function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Public_business_charging"
}, /*#__PURE__*/React.createElement("title", null, "VF_Rityta 1_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M206 226.7h.3c23.5-.2 42.4-19.2 42.5-42.6V72.6l34.8-17.3-12.7-25.4L220.2 55v129.2c0 7.8-6.3 14.1-14.1 14.1h-.1V0H28.4v255.1H0v28.3h262.9v-28.3H206v-28.4zM177.6 28.3v42.5H56.8V28.3h120.8zM56.8 99.2h120.8v155.9H56.8V99.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.3 155.9h-33.5l12.2-42.5-56.9 70.8h33.5l-12.2 42.6z"
}))));